import { useRouter } from 'next/router';
import { isServer } from '@tanstack/react-query';

import PleaseWait from 'components/common/PleaseWait';
import { useAsyncMemo } from 'services/hooks/useAsyncMemo';
import {
  AgilityContentProperties,
  AgilityPage,
  Module,
} from 'types/AgilityTypes';
import { isFeatureSwitchOnClientAsync } from 'services/featureSwitchClientUtils';

export type FeatureSwitchRestrictionFields = {
  featureSwitch?: Array<{
    contentID: number;
    properties: AgilityContentProperties;
    fields: {
      textValue: string;
      sort: string;
    };
    seo: any | null;
  }>;
};

const FeatureSwitchRestriction = ({
  module,
  page,
}: {
  module: Module<FeatureSwitchRestrictionFields>;
  page: AgilityPage;
}) => {
  const router = useRouter();

  const [enabled, loading] = useAsyncMemo(
    async () => {
      if (
        !module.fields?.featureSwitch ||
        module.fields.featureSwitch.length === 0
      ) {
        return true; // No feature switch means no restriction
      }

      const featureSwitches = module.fields.featureSwitch;
      const results = await Promise.all(
        featureSwitches.map(async (feature) => {
          return await isFeatureSwitchOnClientAsync(feature.fields.textValue);
        }),
      );

      return results.includes(true);
    },
    [module.fields?.featureSwitch],
    true,
    'FeatureSwitchRestriction',
    false, // Do not use cache
  );

  if (loading) {
    return <PleaseWait isLoading={true} />;
  }
  if (!loading && !enabled) {
    // redirect to 404 page
    if (!isServer) {
      router.replace(`/404?m=fsr&id=${page.pageID}&p=${page.name}`);
      return null; // Prevent further rendering
    }
    return null;
  }

  return <div></div>;
};

export default FeatureSwitchRestriction;
